import React, { useEffect, useState } from 'react';
import EngineDemoUI from '../../demos/EngineDemoUI';
// @ts-ignore The legacy provider is JavaScript and only wraps the engine.
import { AuthProvider as LegacyAuthProvider } from '../../AuthProvider';
import {
  CloudPresentationDetail, presentationApiClient, PublicPresentationError,
} from '../cloud/PresentationApiClient';

/** The engine never mounts with unvalidated IDs or an error-page fallback. */
export function PublicPresentationViewer({ presentationId }: { presentationId: string }) {
  const [state, setState] = useState<{
    id: string; document?: CloudPresentationDetail; error?: number; code?: string | null;
  }>({ id: presentationId });
  useEffect(() => {
    const controller = new AbortController();
    setState({ id: presentationId });
    presentationApiClient.getPublic(presentationId, controller.signal).then(
      document => { if (!controller.signal.aborted) setState({ id: presentationId, document }); },
      error => {
        if (!controller.signal.aborted) setState({
          id: presentationId,
          error: error instanceof PublicPresentationError ? error.status : 502,
          code: error instanceof PublicPresentationError ? error.code : null,
        });
      },
    );
    return () => controller.abort();
  }, [presentationId]);

  if (state.id !== presentationId || (!state.document && !state.error)) {
    return <main className="ps-callback" role="status">Präsentation wird geladen …</main>;
  }
  if (state.error || !state.document) {
    // Known BFF states get their own wording (#1761); everything else stays generic.
    // There is never a demo or a canvas behind an error.
    const text = state.error === 404
      ? { h: 'Präsentation nicht gefunden', p: 'Dieser Link ist nicht verfügbar oder wurde nicht veröffentlicht.' }
      : state.code === 'PRESENTATION_REVIEW_PENDING'
        ? { h: 'Diese Präsentation wird noch geprüft.', p: 'Bitte versuche es später erneut.' }
        : state.code === 'PRESENTATION_UNAVAILABLE'
          ? { h: 'Diese Präsentation ist derzeit nicht verfügbar.', p: 'Bitte versuche es später erneut.' }
          : { h: 'Präsentation konnte nicht geladen werden', p: 'Bitte versuche es später erneut.' };
    return <main className="ps-not-found" data-viewer-status={state.error} data-viewer-code={state.code ?? undefined}>
      <h1>{text.h}</h1>
      <p>{text.p}</p>
      <a href="/">Zur Startseite</a>
    </main>;
  }
  const document = state.document;
  return <LegacyAuthProvider><EngineDemoUI
    key={presentationId} presentationId={presentationId} viewerMode
    initialPresentation={{ id: presentationId, title: document.title,
      filename: `${document.title}.md`, content: document.content }}
  /></LegacyAuthProvider>;
}
